//Set data for session storage
export const setItemToStorage = (keyname, value) => {
  return localStorage.setItem(keyname, value);
};

//Get data for session storage
export const getItemFromStorage = (keyname) => {
  return localStorage.getItem(keyname);
};

//Remove specific data for session storage
export const removeItemFromStorage = (keyname) => {
  return localStorage.removeItem(keyname);
};

//Clear all data for session storage
export const clearStorage = () => {
  return localStorage.clear();
};
